import { Component, OnInit } from '@angular/core';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { Bandeira } from 'src/app/shared/models/bandeira.enum';

const assets = {
  cb: {
    secondCopy: 'assets/images/icons/ic-cb-segunda-via.svg',
    renegotiation: 'assets/images/icons/ic-cb-renegociacao-home.svg',
    pixPayment: 'assets/images/icons/ic-cb-pix-payment.svg',
    digital: 'assets/images/icons/ic-cb-digital.svg',
    installmentIcon: 'assets/images/icons/ic-cb-parcelamento.svg'
  },
  pf: {
    secondCopy: 'assets/images/icons/ic-pf-segunda-via.svg',
    renegotiation: 'assets/images/icons/ic-pf-renegociacao-home.svg',
    pixPayment: 'assets/images/icons/ic-pf-pix-payment.svg',
    digital: 'assets/images/icons/ic-pf-digital.svg',
    installmentIcon: 'assets/images/icons/ic-pf-parcelamento.svg'
  }
}

@Component({
  selector: 'app-benefits-section',
  templateUrl: './benefits-section.component.html',
  styleUrls: ['./benefits-section.component.scss']
})
export class BenefitsSectionComponent implements OnInit {
  isCasasBahia = this.autenticacaoService.bandeira === Bandeira.CASAS_BAHIA

  constructor(
    private autenticacaoService: AutenticacaoService
  ) { }

  ngOnInit(): void {
  }


  get assets() {
    if (this.isCasasBahia) {
      return assets.cb;
    }

    return assets.pf;
  }

  handleOpenCarneDigital() {
    window.open('https://www.casasbahia.com.br/hotsite/carne-digital.aspx?icid=hotbarcdc2024', '_blank');
  }

}
